;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('disableEmailValidator', disableEmailValidator)

  function disableEmailValidator () {
    return {
      require: 'ngModel',
      scope: {
        disableEmailValidator: '<'
      },
      link: function (scope, elm, attrs, ctrl) {
        if (scope.disableEmailValidator) {
          var validator = function (value) {
            return value
          }
          ctrl.$validators = {
            email: validator
          }
        }
      }
    }
  }
})()
